import FilterCheckboxGroup from '@cinch/oxd-components/filter-checkbox-group/src'
import FilterLozengeGroup from '@cinch/oxd-components/filter-lozenge-group/src'
import FilterMakeModel from '@cinch/oxd-components/filter-make-model/src'
import FilterRadio from '@cinch/oxd-components/filter-radio/src'
import FilterRange from '@cinch/oxd-components/filter-range/src'
import { SelectFieldWrapper } from '@cinch/oxd-components/final-form-wrappers/src'
import { setToInt } from '@cinch/oxd-utils/form/src'
import React from 'react'
import { Field, Fields } from 'redux-form'
import { FILTER_TYPE } from './listing-filters-config'

import * as styles from './listing-filters.module.css'

const rangeComponent = (props: any) => {
  const { config } = props

  return (
    <>
      <Field
        component={(componentProps: any) => <SelectFieldWrapper {...componentProps} />}
        label={config.from.label || 'From'}
        placeholder="All"
        placeholderValue={config.from.initialValue}
        {...config.from}
        name={config.from.key}
        compareForward={false}
        compareValue={props[config.to.key].input.value}
        parse={setToInt}
      />
      <Field
        component={(componentProps: any) => <SelectFieldWrapper {...componentProps} />}
        label={config.to.label || 'To'}
        placeholder="All"
        placeholderValue={config.to.initialValue}
        {...config.to}
        name={config.to.key}
        compareForward={true}
        compareValue={props[config.from.key].input.value}
        parse={setToInt}
      />
    </>
  )
}

export const getAccordionFilter = (config: any, change: any, makes: any, models: any, selectedMake?: any) => {
  switch (config.type) {
    case FILTER_TYPE.CHECKBOX: {
      return (
        <div className={styles.filterContentBody}>
          <FilterCheckboxGroup name={config.key} {...config} onReset={() => change(config.key, '')} />
        </div>
      )
    }
    case FILTER_TYPE.SELECT_RANGE: {
      return (
        <div className={`${styles.filterContentBody} ${styles.selectRange}`}>
          <Fields config={config} names={[config.from.key, config.to.key]} component={rangeComponent} />
        </div>
      )
    }
    case FILTER_TYPE.SELECT: {
      return (
        <div className={styles.filterContentBody}>
          <Field component={SelectFieldWrapper} name={config.key} {...config} placeholder={config.label} />
        </div>
      )
    }
    case FILTER_TYPE.RADIO: {
      return (
        <div className={styles.filterContentBody}>
          {config.options.map((option: any) => (
            <Field key={option.value} component={FilterRadio} {...option} />
          ))}
        </div>
      )
    }
    case FILTER_TYPE.MAKE_MODEL: {
      const modelConfig = { ...config.model, options: models }
      const makeConfig = { ...config.make, options: makes }

      return (
        <FilterMakeModel
          makeConfig={makeConfig}
          modelConfig={modelConfig}
          selectedMake={selectedMake}
          onResetMake={() => {
            change(config.make.key, '')
            change(config.model.key, '')
          }}
        />
      )
    }
    case FILTER_TYPE.SLIDER: {
      return (
        <div className={styles.filterContentBody}>
          <Field label={config.label} component={FilterRange} name={config.key} {...config.options} />
        </div>
      )
    }
    default:
      return null
  }
}

export const getLozengeGroups = (config: any, models?: any, makes?: any) => {
  switch (config.type) {
    case FILTER_TYPE.SELECT_RANGE: {
      return [
        <FilterLozengeGroup
          name={config.from.key}
          {...config.from}
          key={`lozenge-${config.from.key}`}
          labelPrefix="From: "
        />,
        <FilterLozengeGroup
          name={config.to.key}
          {...config.from}
          key={`lozenge-${config.to.key}`}
          labelPrefix="To: "
        />,
      ]
    }
    case FILTER_TYPE.SLIDER: {
      return config && config.options && config.options.initialValue ? (
        <FilterLozengeGroup {...config} initialValue={config.options.initialValue} name={config.key} />
      ) : (
        <FilterLozengeGroup {...config} name={config.key} />
      )
    }
    case FILTER_TYPE.MAKE_MODEL: {
      return [
        <FilterLozengeGroup
          name={config.make.key}
          {...config.make}
          options={makes}
          key={`lozenge-${config.make.key}`}
          labelPrefix="Make: "
        />,
        <FilterLozengeGroup
          name={config.model.key}
          {...config.model}
          options={models}
          key={`lozenge-${config.model.key}`}
          labelPrefix="Model: "
        />,
      ]
    }
    default: {
      return <FilterLozengeGroup name={config.key} {...config} />
    }
  }
}
